import { EventsTrend, GetEventsTrendParams } from '@ketch-com/windlass/dist/dataSentry/v1/events/events'
import { API } from 'utils/api/api'
import { formatRequestString } from 'utils/helpers/api/queryString'

export const fetchDataSentryEventsTrend = ({
  'start-date': StartDate,
  'end-date': EndDate,
  'property-codes': PropertyCodes,
}: GetEventsTrendParams) => {
  return API.get<EventsTrend>(
    formatRequestString({
      entityUrl: `/api/v1/data-sentry/events/trend`,
      params: {
        filters: {
          'start-date': StartDate,
          'end-date': EndDate,
          'property-codes': PropertyCodes,
        },
      },
    }),
  )
}
